import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemRequest extends IBaseRequest {
    limit:               number;
    offset:              number;
    orderBy?:             string;
    countOnly?:           boolean;
    orderByType?:         string;
    relatedItem?:         string;
    treeHandle?:          string;
    type?:                string;
    priceList?:           string;
    searchName?:          string;
    status?:              string;
    statusShow?:          string;
    refId?:               string;
    field0?:              string;
    field0_id?:           string;
    field1?:              string;
    field1_id?:           string;
    field2?:              string;
    field2_id?:           string;
    field3?:              string;
    field3_id?:           string;
    field4?:              string;
    field4_id?:           string;
    field5?:              string;
    field5_id?:           string;
    field6?:              string;
    field6_id?:           string;
    field7?:              string;
    field7_id?:           string;
    field8?:              string;
    field8_id?:           string;
    field9?:              string;
    field9_id?:           string;
    manufacturer?:        string;
    refIdExact?:          string;
    closingBalanceQty?:   string;
    availableBalanceQty?: string;
    externalSystem?:      string;
    externalId?:          string;
}

export class ListItemRequest extends BaseRequest implements IListItemRequest {
    public limit:               number;
    public offset:              number;
    public orderBy?:             string;
    public countOnly?:           boolean;
    public orderByType?:         string;
    public relatedItem?:         string;
    public treeHandle?:          string;
    public type?:                string;
    public priceList?:           string;
    public searchName?:          string;
    public status?:              string;
    public statusShow?:          string;
    public refId?:               string;
    public field0?:              string;
    public field0_id?:           string;
    public field1?:              string;
    public field1_id?:           string;
    public field2?:              string;
    public field2_id?:           string;
    public field3?:              string;
    public field3_id?:           string;
    public field4?:              string;
    public field4_id?:           string;
    public field5?:              string;
    public field5_id?:           string;
    public field6?:              string;
    public field6_id?:           string;
    public field7?:              string;
    public field7_id?:           string;
    public field8?:              string;
    public field8_id?:           string;
    public field9?:              string;
    public field9_id?:           string;
    public manufacturer?:        string;
    public refIdExact?:          string;
    public closingBalanceQty?:   string;
    public availableBalanceQty?: string;
    public externalSystem?:      string;
    public externalId?:          string;

    constructor(server: string, session: string, limit: number, offset: number, otherOptions: any) {
        super(server, session);
        this.limit = limit;
        this.offset = offset;
        this.orderBy = otherOptions.orderBy;
        this.countOnly = otherOptions.countOnly;
        this.orderByType = otherOptions.orderByType;
        this.relatedItem = otherOptions.relatedItem;
        this.treeHandle = otherOptions.treeHandle;
        this.type = otherOptions.type;
        this.priceList = otherOptions.priceList;
        this.searchName = otherOptions.searchName;
        this.status = otherOptions.status;
        this.statusShow = otherOptions.statusShow;
        this.refId = otherOptions.refId;
        this.field0 = otherOptions.field0;
        this.field0_id = otherOptions.field0_id;
        this.field1 = otherOptions.field1;
        this.field1_id = otherOptions.field1_id;
        this.field2 = otherOptions.field2;
        this.field2_id = otherOptions.field2_id;
        this.field3 = otherOptions.field3;
        this.field3_id = otherOptions.field3_id;
        this.field4 = otherOptions.field4;
        this.field4_id = otherOptions.field4_id;
        this.field5 = otherOptions.field5;
        this.field5_id = otherOptions.field5_id;
        this.field6 = otherOptions.field6;
        this.field6_id = otherOptions.field6_id;
        this.field7 = otherOptions.field7;
        this.field7_id = otherOptions.field7_id;
        this.field8 = otherOptions.field8;
        this.field8_id = otherOptions.field8_id;
        this.field9 = otherOptions.field9;
        this.field9_id = otherOptions.field9_id;
        this.manufacturer = otherOptions.manufacturer;
        this.refIdExact = otherOptions.refIdExact;
        this.closingBalanceQty = otherOptions.closingBalanceQty;
        this.availableBalanceQty = otherOptions.availableBalanceQty;
        this.externalSystem = otherOptions.externalSystem;
        this.externalId = otherOptions.externalId;
    }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');

    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.orderByType, 'orderByType');
    parameters += this.makeNode(this.relatedItem, 'relatedItem');
    parameters += this.makeNode(this.treeHandle, 'treeHandle');
    parameters += this.makeNode(this.type, 'type');
    parameters += this.makeNode(this.priceList, 'priceList');
    parameters += this.makeNode(this.searchName, 'searchName');
    parameters += this.makeNode(this.status, 'status');
    parameters += this.makeNode(this.statusShow, 'statusShow');
    parameters += this.makeNode(this.refId, 'refId');
    parameters += this.makeNode(this.field0, 'field0');
    parameters += this.makeNode(this.field0_id, 'field0_id');
    parameters += this.makeNode(this.field1, 'field1');
    parameters += this.makeNode(this.field1_id, 'field1_id');
    parameters += this.makeNode(this.field2, 'field2');
    parameters += this.makeNode(this.field2_id, 'field2_id');
    parameters += this.makeNode(this.field3, 'field3');
    parameters += this.makeNode(this.field3_id, 'field3_id');
    parameters += this.makeNode(this.field4, 'field4');
    parameters += this.makeNode(this.field4_id, 'field4_id');
    parameters += this.makeNode(this.field5, 'field5');
    parameters += this.makeNode(this.field5_id, 'field5_id');
    parameters += this.makeNode(this.field6, 'field6');
    parameters += this.makeNode(this.field6_id, 'field6_id');
    parameters += this.makeNode(this.field7, 'field7');
    parameters += this.makeNode(this.field7_id, 'field7_id');
    parameters += this.makeNode(this.field8, 'field8');
    parameters += this.makeNode(this.field8_id, 'field8_id');
    parameters += this.makeNode(this.field9, 'field9');
    parameters += this.makeNode(this.field9_id, 'field9_id');
    parameters += this.makeNode(this.manufacturer, 'manufacturer');
    parameters += this.makeNode(this.refIdExact, 'refIdExact');
    parameters += this.makeNode(this.closingBalanceQty, 'closingBalanceQty');
    parameters += this.makeNode(this.availableBalanceQty, 'availableBalanceQty');
    parameters += this.makeNode(this.externalSystem, 'externalSystem');
    parameters += this.makeNode(this.externalId, 'externalId');

    return super.wrapperXml('ListItem', parameters);
  }
}
